import { singleline } from "@core/foundation/string";
import {
  CursorPaginationSchema,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { mcpApi } from "@core/ports/mcp";
import { z } from "@core/zod";

import { PROJECT_DOMAIN } from "@platform/core";

import { GENERATION_SERVICE } from "../config/index.ts";
import {
  Generation,
  GenerationIdSchema,
  GenerationRequestSchema,
} from "../models/index.ts";

export const generationMcpApi = mcpApi(
  {
    domain: `mcp.${GENERATION_SERVICE.LABEL}.${PROJECT_DOMAIN}`,
    serverInfo: { name: GENERATION_SERVICE.LABEL, version: "0.1.0" },
  },
  {
    get_generation: {
      description: singleline`
        Returns one of your generations with its status, its error when it
        failed, and the ids of the images it produced.
      `,
      inputSchema: z.object(
        { id: GenerationIdSchema },
        { id: "The id of the generation" },
      ),
      resultSchema: z.object(
        { generation: Generation.schema },
        { generation: "The generation" },
      ),
    },
    list_generations: {
      description: singleline`
        Returns a page of your generations, with the cursor the next page starts
        from.
      `,
      inputSchema: CursorPaginationSchema,
      resultSchema: cursorPaginatedResponse(Generation.schema),
    },
    start_generation: {
      description: singleline`
        Starts an image generation charged to your credit and returns it as
        pending. Refused when your balance does not cover the price. Read the
        result with get_generation.
      `,
      inputSchema: z.object(
        {
          description: Generation.shape.description,
          request: GenerationRequestSchema,
        },
        {
          description: Generation.descriptions.description,
          request: "The model and its parameters",
        },
      ),
      resultSchema: z.object(
        { generation: Generation.schema },
        { generation: "The generation" },
      ),
    },
  },
);
